export default {
    archives: 'Archives',
    chatArchives: 'Chat Archives',
    loadMore: 'Load More',
    empty: {
        before: 'No messages yet.',
        after: 'for a user to talk to :)',
    },
    hideMessages: 'Hide Messages',
    hideList: 'Hide list',
    showList: 'Show list',
    hide: 'Hide',
    markAllRead: 'Mark All Read',
    messages: 'Messages',
    messageSettings: 'Message Settings',
    noMatchingUsers: 'No matching users',
    noMessagesExchangedYet: 'No private messages exchanged yet...',
    privateMessagesBanned: 'Sorry, these private messages are banned',
    sendPrivateMessages: 'send private messages',
    search: 'Search usernames',
    settings: 'Settings',
    showPMList: 'Show messages list',
    title: 'Private Messages',
    users: 'users',
    viewableConversation: 'for a viewable conversation.',
}
